const translation = {
  title: 'Resource Quotas',
  create: {
    title: 'Create Resource Quota',
  },
  detail: {
    title: 'Resource Quota Details',
  },
  edit: {
    title: 'Edit Resource Quota',
  },
  form: {
    name: 'Quota Name',
    nameTooltip: 'Name of the resource quota',
    description: 'Description',
    descriptionTooltip: 'Description of the resource quota',
    cpu: 'CPU Quota',
    cpuTooltip: 'CPU resource quota',
    memory: 'Memory Quota',
    memoryTooltip: 'Memory resource quota',
    gpu: 'GPU Quota',
    gpuTooltip: 'GPU resource quota',
    storage: 'Storage Quota',
    storageTooltip: 'Storage resource quota',
    compute: 'Compute Quota',
    computeTooltip: 'Compute resource quota',
    project: 'Project',
    projectTooltip: 'Select the project for the resource quota',
    queue: 'Resource Queue',
    queueTooltip: 'Select the target resource queue for quota allocation',
    expiredAt: 'Expired At',
    expiredAtTooltip: 'Resource quota will automatically expire after this time. Leave empty for permanent validity',
    selectExpiredAt: 'Select expired time',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    delete: 'Delete',
    domain: 'Domain',
    domainTooltip: 'Select the domain (top-level organization unit) for the resource quota',
    user: 'User',
    userTooltip: 'Select the target user for resource quota allocation',
    quotaType: 'Quota Type',
    quotaTypeTooltip: 'Select quota type: storage disk or image registry',
    quotaTypeDisk: 'Storage Disk',
    quotaTypeHarbor: 'Image Repository',
    storageCluster: 'Storage Cluster',
    storageClusterTooltip: 'Select the storage cluster associated with the quota',
    registry: 'Image Repository',
    registryTooltip: 'Select the image registry associated with the quota',
    storageSize: 'Storage Size',
    storageSizeTooltip: 'Set the maximum storage capacity allowed',
  },
  list: {
    name: 'Quota Name',
    description: 'Description',
    cpu: 'CPU',
    memory: 'Memory',
    gpu: 'GPU',
    storage: 'Storage',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    project: 'Project',
    user: 'User',
    queue: 'Resource Queue',
    expiredAt: 'Expired At',
    search: 'Search',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    error: 'Error',
  },
  message: {
    createSuccess: 'Resource quota created successfully',
    updateSuccess: 'Resource quota updated successfully',
    deleteSuccess: 'Resource quota deleted successfully',
    deleteConfirm: 'Are you sure you want to delete this resource quota?',
    deleteWarning: 'This action cannot be undone',
  },
}

export default translation
